import { MapViewProjectionFromData } from '@app/core/shared/components/field-view/models/field-view';
import { View } from 'ol';
import { getCenter, getWidth } from 'ol/extent';
import { transformExtent } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import proj4x from 'proj4';

// work around for bumped OL bug with proj4.defs and register
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const proj4 = (proj4x as any).default || proj4x;

export default class MapViewUtility {
  private static _defaultMapProjection = 'EPSG:3857';

  static getDefaultMapProjection() {
    return this._defaultMapProjection;
  }

  static getMapViewFromData(
    value: MapViewProjectionFromData,
    sourceDataLabel: string,
    snackbarCallback?: (message: string) => void
  ): View {
    const guidanceMessage = `\n\nPlease check your Projection Zone is compatible with your ${sourceDataLabel} Data (Eastings & Northings).`;

    if (!value) {
      return this.getDefaultMapView();
    } else {
      const { minX, maxX, minY, maxY, projectionZone } = value;
      const extent = [minX, minY, maxX, maxY];

      let transformedExtent;
      try {
        transformedExtent = transformExtent(extent, projectionZone, this._defaultMapProjection);

        const center = getCenter(transformedExtent);
        if (!Array.isArray(center) || center.some(v => isNaN(v) || !isFinite(v))) {
          snackbarCallback?.(`Error transforming extent for projection ${projectionZone}.${guidanceMessage}`);
          return this.getDefaultMapView();
        }

        return new View({
          center,
          projection: this._defaultMapProjection,
          zoom: Math.max(0, 16 - Math.log2(getWidth(transformedExtent) / 500))
        });
      } catch (error) {
        snackbarCallback?.(`An error occurred during map view transformation.${guidanceMessage}`);
        return this.getDefaultMapView();
      }
    }
  }

  static getDefaultMapView(): View {
    return new View({
      center: [0, 0],
      projection: this._defaultMapProjection,
      zoom: 2
    });
  }

  static registerProj4(projectionZone: string, proj4Value: string) {
    proj4.defs(projectionZone, proj4Value);
    register(proj4);
  }
}
